import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, getLogoutRedirectUri } from "@/msalConfig";
import { b2cPolicies } from "@/b2cPolicies";
import store from "@/store";
import * as broadcast from "@/plugins/broadcastChannel";
import * as auth from "@/plugins/auth";

export const msalInstance = new PublicClientApplication(msalConfig);

export function handleAuthentication() {

  return msalInstance
    .handleRedirectPromise()
    .then((response) => {
      if (response) {
        return handleAuthenticatedUser(response);
      }
      return Promise.resolve();
    })
    .catch((error) => {
      console.error("Authentication error:", error);
      return Promise.reject(error);
    });
}

export function logout() {
  store.dispatch("auth/logout");
  broadcast.sendLogoutSignal();

  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.logoutRedirect();
  } else {
    // handle logout when user comes from Admin 1 (no MSAL instance)
    window.location = getLogoutRedirectUri();
  }
}

export function initiateLogin() {
  const request = getSsoSilentRequestBody();

  return msalInstance
    .ssoSilent(request)
    .then(async (response) => {
      await handleAuthenticatedUser(response);
    })
    .catch((error) => {
      msalInstance.loginRedirect({
        scopes: b2cPolicies.scopes,
      });
    });
}

export async function extendSession() {
  const accounts = msalInstance.getAllAccounts();

  if (accounts.length === 0) {
    return;
  }

  const request = {
    account: accounts[0],
    scopes: b2cPolicies.scopes,
  };

  try {
    const accessToken = await msalInstance.acquireTokenSilent(request);
    handleAuthenticatedUser(accessToken);
    return true;
  } catch (error) {
    return error;
  }
}

async function handleAuthenticatedUser(response) {
  const userId = response.account.idTokenClaims.extension_efundid;
  const accessToken = response.accessToken;
  const currentUserId = store.getters["auth/getUserId"];

  // Only reset state and fetch permissions if it's a different user or no current user
  const needsPermissionRefresh = !currentUserId || currentUserId !== userId;

  if (needsPermissionRefresh) {
    store.dispatch("auth/resetState");
  }

  // Always update authentication with token.
  // Don't trust userId from token due to issues with initial login.
  // Gets filled in during permissions fetch
  store.dispatch("auth/setAuthentication", {
    accessToken: accessToken,
  });

  return auth.getPermissions(accessToken);
}

function getSsoSilentRequestBody() {
  const userEmail = store.getters["auth/getUserEmail"];

  return userEmail
    ? {
        scopes: b2cPolicies.scopes,
        loginHint: userEmail,
      }
    : {
        scopes: b2cPolicies.scopes,
      };
}
